<template>
  <div class="login-container">
    <el-card class="login-card">
      <div class="login-header">
        <img src="@/assets/sud.png" class="logo" alt="logo">
        <h2 class="title">系统登录</h2>
      </div>

      <el-form ref="loginForm" :model="form" :rules="rules" @keyup.enter="handleLogin">
        <el-form-item prop="username">
          <el-input v-model="form.username" placeholder="请输入用户名" prefix-icon="User" clearable />
        </el-form-item>

        <el-form-item prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入密码" prefix-icon="Lock" show-password
            clearable />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" class="login-btn" :loading="loading" @click="handleLogin">
            立即登录
          </el-button>
        </el-form-item>
      </el-form>
      <!-- 增加前台入口按钮 -->
      <el-button type="primary" @click="goToBigScreen">进入大屏展示</el-button>
    </el-card>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import urlencode from "urlencode";

import axios from 'axios';

const router = useRouter()
const loginForm = ref(null)

const form = ref({
  username: '',
  password: ''
})

const rules = ref({
  username: [
    { required: true, message: '用户名不能为空', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '密码不能为空', trigger: 'blur' },
    { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
  ]
})

const loading = ref(false)

// 获取数据的函数
const fetchData = async () => {
  try {
    console.log(process.env.VUE_APP_BASE_URL)
    var user_name = urlencode(form.value.username);
    var pass_word = urlencode(form.value.password);
    console.log(user_name, pass_word)
    var url = `${process.env.VUE_APP_BASE_URL}/api/login/user?user_name=${user_name}&password=${pass_word}`;
    console.log(url)
    const response = await axios.get(url);
    var auth = response.data.auth;
    console.log("fetchData OK.");
    if (auth == "OK") {
      return true;
    }
  } catch (error) {
    console.log(error)
  }
  return false
};

const handleLogin = async () => {
  if (!loginForm.value) return

  // 修复2：使用 async/await 重构验证流程
  try {
    const valid = await loginForm.value.validate()
    if (!valid) return

    loading.value = true

    // 修复3：调用实际登录方法
    const loginSuccess = await fetchData()

    if (loginSuccess) {
      localStorage.setItem('token', 'demo-token')
      router.push('/data-list')
      ElMessage.success('登录成功')
    } else {
      ElMessage.error('用户名或密码错误')
    }
  } catch (error) {
    console.error('验证失败:', error)
  } finally {
    loading.value = false
  }
}

const goToBigScreen = () => {
  // 可以判断 token 是否存在，也可以允许游客访问
  router.push('/bigscreen')
}


</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(145deg, #f0f2f5 0%, #e6f7ff 100%);
}

.login-card {
  width: 420px;
  padding: 40px 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.logo {
  width: 80px;
  height: 80px;
  margin-bottom: 15px;
}

.title {
  color: #303133;
  font-size: 24px;
  margin: 10px 0;
}

.login-btn {
  width: 100%;
  height: 42px;
  font-size: 16px;
  letter-spacing: 2px;
}
</style>